export const headerNames = [
  {
    label: 'Name',
    name: 'name',
    sortable: true,
  },
  {
    label: '',
    name: '',
    sortable: false,
  },
  {
    label: 'Steps',
    name: 'totalSteps',
    sortable: true,
  },
  {
    label: 'Duration (Days)',
    name: 'totalDays',
    sortable: true,
  },
  {
    label: 'Created',
    name: 'creationDatetime',
    sortable: true,
  },
  {
    label: 'Last Update',
    name: 'lastEntityUpdate',
    sortable: true,
  },
  {
    label: 'Created by',
    name: 'createdBy',
    sortable: true,
  },
  {
    label: 'Visibility',
    name: 'editMode',
    sortable: true,
  },
  {
    label: 'Status',
    name: 'status',
    sortable: false,
  },
];

export const emailAutomationHeaderNames = [
  {
    label: 'Name',
    name: 'name',
    sortable: true,
  },
  {
    label: '',
    name: '',
    sortable: false,
  },
  {
    label: 'Steps',
    name: 'totalSteps',
    sortable: true,
  },
  {
    label: 'Duration (Days)',
    name: 'totalDays',
    sortable: true,
  },
  {
    label: 'Prospects',
    name: 'prospectCount',
    sortable: true,
  },
  {
    label: 'Active Count',
    name: 'activeCount',
    sortable: true,
  },
  {
    label: 'Automated',
    name: 'automatedPercentage',
    sortable: true,
  },
  {
    label: 'Opted-out',
    name: 'optOutCount',
    sortable: true,
  },
  {
    label: 'Created',
    name: 'creationDatetime',
    sortable: true,
  },
  {
    label: 'Last Update',
    name: 'lastEntityUpdate',
    sortable: true,
  },
  {
    label: 'Created by',
    name: 'createdBy',
    sortable: true,
  },
  {
    label: 'Visibility',
    name: 'editMode',
    sortable: true,
  },
  {
    label: 'Status',
    name: 'status',
    sortable: false,
  },
];
